import { Input, Typography } from '@material-tailwind/react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { DocumentNumberInput } from '@/components/document-number-input'
import { Checkbox, Radio } from '@material-tailwind/react'
import CustomSelect from '@/shared/components/custom-select'
import { InputHelperText } from '@/shared/components/input-helper-text'
import { AddressForm } from '@/components/address-form'
import { GroupInput } from '@/components/v2/group-input'

export const EmployeeInformationForm = ({ countryOptions }) => {
  const { values, handleChange, setFieldValue, getFieldProps, errors, touched } =
    useFormikContext()

  const { t } = useTranslation()

  const maritalStatusOptions = [
    { label: 'Soltero/a', value: 'soltero' },
    { label: 'Casado/a', value: 'casado' },
    { label: 'Viudo/a', value: 'viudo' },
    { label: 'Divorciado/a', value: 'divorciado' },
    { label: 'Conviviente civil', value: 'conviviente' },
    { label: 'Separado/a judicialmente', value: 'separado' }
  ]

  return (
    <>
      <div className='grid grid-cols-2 gap-3'>
        <div>
          <Input
            required
            label='Nombres'
            value={values.name}
            onChange={handleChange}
            name='name'
            error={Boolean(errors.name)}
          />
          <InputHelperText label={errors.name} color='red' />
        </div>
        <div>
          <Input
            required
            label='Apellidos'
            value={values.last_name}
            onChange={handleChange}
            name='last_name'
            error={Boolean(errors.last_name)}
          />
          <InputHelperText label={errors.last_name} color='red' />
        </div>
      </div>

      <div className='col-span-3 grid grid-cols-3 gap-3'>
        <div className='flex flex-col gap-2'>
          <DocumentNumberInput
            required
            className='grow'
            label={t('documentNumber.one')}
            value={values.document_number}
            error={Boolean(errors.document_number)}
            onChange={handleChange}
            name='document_number'
          />
          <Checkbox
            name='has_local_document_number'
            ripple={false}
            className='hover:before:opacity-0'
            containerProps={{ className: 'p-0' }}
            labelProps={{ className: 'ml-1' }}
            checked={!values.has_local_document_number}
            onChange={(event) =>
              setFieldValue('has_local_document_number', !event.target.checked)
            }
            label='No tiene RUT'
          />
          <InputHelperText label={errors.document_number} color='red' />
        </div>

        <div className='flex flex-col gap-2'>
          <Input
            required
            className='grow'
            type='date'
            label={t('common.birthDate')}
            value={values.birth_date}
            onChange={handleChange}
            name='birth_date'
            error={Boolean(errors.birth_date)}
          />
          <InputHelperText label={errors.birth_date} color='red' />
        </div>

        <div className='flex flex-col gap-2'>
          <CustomSelect
            required
            className='grow'
            placeholder={t('country.one')}
            options={countryOptions}
            value={countryOptions.find(option => option.value === values.country_id) || values.country_id}
            onChange={({ value }) => setFieldValue('country_id', value)}
            error={Boolean(errors.country_id)}
          />
          <InputHelperText label={errors.country_id} color='red' />
        </div>
      </div>

      <hr className='my-6' />

      <div className='grid grid-cols-2 gap-3'>
        <Input
          type='email'
          label='E-mail'
          value={values.email || ''}
          name='email'
          onChange={handleChange}
        />

        <Input
          type='text'
          label='Teléfono'
          value={values.phone || ''}
          name='phone'
          onChange={handleChange}
          placeholder='+56 9 1234 5678'
        />

        <div className='grid grid-cols-2 gap-4 col-span-2'>
          <AddressForm />
        </div>

        <div className='col-span-2'>
          <CustomSelect
            placeholder='Estado civil'
            options={maritalStatusOptions}
            value={maritalStatusOptions.find(opt => opt.value === values.marital_status) || null}
            onChange={({ value }) => setFieldValue('marital_status', value)}
          />
        </div>
      </div>

      <hr className='my-6' />

      <div className='grid grid-cols-3'>
        <div className='grid grid-flow-row gap-0'>
          <Typography variant='small' className='text-gray-500 font-semibold'>
            {t('gender.one')}
          </Typography>
          <Radio
            value='female'
            name='gender'
            label='Femenino'
            checked={values.gender === 'female'}
            onChange={getFieldProps('gender').onChange}
          />
          <Radio
            value='male'
            name='gender'
            label='Masculino'
            checked={values.gender === 'male'}
            onChange={getFieldProps('gender').onChange}
          />
        </div>
        <div className='grid grid-flow-row gap-0'>
          <Typography variant='small' className='text-gray-500 font-semibold'>
            ¿Situación de discapacidad?
          </Typography>
          <Radio
            name='disability'
            label='Si'
            value={true}
            checked={values.disability === 'true' || values.disability === true}
            onChange={getFieldProps('disability').onChange}
          />
          <Radio
            name='disability'
            label='No'
            checked={values.disability === 'false' || values.disability === false}
            value={false}
            onChange={getFieldProps('disability').onChange}
          />
        </div>

        <div className='grid grid-flow-row gap-0'>
          <Typography variant='small' className='text-gray-500 font-semibold'>
            ¿Es pensionado?
          </Typography>
          <Radio
            name='pensioner'
            value={true}
            label='Si'
            checked={values.pensioner === 'true' || values.pensioner === true}
            onChange={getFieldProps('pensioner').onChange}
          />
          <Radio
            name='pensioner'
            value={false}
            label='No'
            checked={values.pensioner === 'false' || values.pensioner === false}
            onChange={getFieldProps('pensioner').onChange}
          />
        </div>
      </div>
    </>
  )
}

EmployeeInformationForm.propTypes = {
  countryOptions: PropTypes.array.isRequired
}